import { type VivaStatus, vivaStatus } from '../../../dtos';

export function shouldHideAusschreibungCards(status: VivaStatus | undefined | null): boolean {
  return status === vivaStatus.FREIGEGEBEN;
}
